<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="boxVo.pkid > 0 ? '编辑':'新建'"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="boxVo"
          :rules="ruleValidate"
          class="form"
          label-width="90px">
        <el-form-item label="客户名称" prop="customerName">
          <el-input v-model="boxVo.customerName" readonly>
            <el-button slot="append" icon="el-icon-search" :disabled="boxVo.pkid > 0" @click="$refs.selectCustomer.open()">选择</el-button>
          </el-input>
          <customer-select ref="selectCustomer" @select="selectCustomer"/>
        </el-form-item>
        <el-form-item label="木箱备注" prop="boxText">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model.trim="boxVo.boxText" placeholder="请输入"/>
          </div>
        </el-form-item>
      </el-form>
      <customer-select ref="selectCustomer" @select="onSelectCustomer"/>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constants from "../../../util/constants";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect.vue";

  export default {
    name: "CustomerBoxEdit",
    components: {CustomerSelect},
    data() {
      return {
        constants,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        sendType: "1",
        boxVo: {
          pkid: 0,
          customerNo: "",
          customerName: "",
          boxText: "",
        },
        ruleValidate: {
          boxText: {required: true, message: "不能为空", trigger: "blur"},
          customerName: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.boxVo.pkid = row.pkid;
        this.dialogVisible = true;
        if (this.boxVo.pkid > 0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `baseCustomerboxes/${this.boxVo.pkid}`)
          .then(resp => {
            this.boxVo = resp;
          });
      },

      onSelectCustomer(row) {
        this.boxVo.customerName=row.customerName;
        this.boxVo.customerNo=row.customerID;
      },
      
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.boxVo.pkid > 0) {
              this.$http
                .put("basic", "baseCustomerboxes", this.boxVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "baseCustomerboxes", this.boxVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
